import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogService } from 'primeng/dynamicdialog';
import { forkJoin } from 'rxjs';
import { tap } from 'rxjs/operators';
import { BaseComponent } from 'src/app/core/base/base.component';
import { Utils } from 'src/app/core/utils/khuyana.utils';
import { PatientDialogComponent } from '../../common/patient/components/patient-dialog.component';
import { PatientService } from '../../common/patient/patient.service';
import { VITAL_SIGN } from './general-vital-sign.constants';
import { GeneralVitalSignService } from './general-vital-sign.service';
import { CommonTurnViewModel } from 'src/app/model/common/turn.view';
import { CommonPatientViewModel } from 'src/app/model/common/patient.view';
import { GeneralHeaderModel } from 'src/app/model/general/header';

@Component({
  selector: 'ms-general-vital-sign',
  templateUrl: './general-vital-sign.component.html',
  styleUrls: ['./general-vital-sign.styles.scss']
})
export class GeneralVitalSignComponent extends BaseComponent {

  readonly screen = VITAL_SIGN;
  protected setScreen = true;
  turn: CommonTurnViewModel = {};
  patient: CommonPatientViewModel = {};
  header: GeneralHeaderModel = {};

  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected service: GeneralVitalSignService,
    protected patientService: PatientService,
    protected dialogService: DialogService
  ) {
    super();
  }

  onInit = () => {
    this.subscriptions.push(
      this.route.queryParams.subscribe((params: CommonTurnViewModel) => {
        this.turn = params;
        this.header.turn = params.id;
        this.header.patient = params.patient;
        this.subscriptions.push(
          forkJoin([
            this.patientService.getPatientViewById(this.turn.patient!),
            this.service.getHeader(this.turn.id!)
          ]).subscribe(this.subscribeAll)
        );
      })
    );
  }

  openModal = () =>
    this.subscriptions.push(
      this.patientService.getPatientById(this.patient.id!).subscribe(
        (patient) => {
          this.subscriptions.push(
            this.patientService.getPersonById(patient.person!).subscribe()
          );
          this.patientService.openPatientDialog(false, PatientDialogComponent).onClose
            .pipe(tap(this.patientService.patientOnClose))
            .subscribe(modalResult => {
              if (modalResult) {
                this.patient = modalResult;
              }
            });
        }
      )
    )

  save = () => {
    this.service.setLoadingState();
    this.subscriptions.push(
      this.service.save(this.header).subscribe(_ => {
        this.router.navigate(['/turno']);
      })
    );
  }

  private subscribeAll = (data: any[]) => {
    const patient = data[0];
    const header = data[1];
    this.patient = patient;
    if (this.patient.dateBorn) {
      this.patient.dateBorn = new Date(this.patient.dateBorn);
    }
    this.patient.ageLabel = Utils.transformAge(this.patient.age);
    this.header = header;
  }

}
